import { ICache, IDbCache } from './cache';
import { IDbCacheDAO } from './db-cache-dao';

export const getMockCache = (): ICache => {
  return {
    read: jest.fn(),
    write: jest.fn(),
    clear: jest.fn(),
    clearByBucket: jest.fn(),
  };
};

export const getMockDbCache = (): IDbCache => {
  return {
    ...getMockCache(),
    readByBucket: jest.fn(),
  };
};

export const getMockCachedValueDAO: () => jest.Mocked<IDbCacheDAO> = () => {
  return {
    findByBucket: jest.fn().mockResolvedValue([]),
    findByHash: jest.fn().mockResolvedValue(null),
    upsert: jest.fn().mockResolvedValue(null),
    removeByHash: jest.fn().mockResolvedValue(null),
    removeAll: jest.fn().mockResolvedValue(null),
    removeByBucket: jest.fn().mockResolvedValue(null),
  };
};
